import React, { FC, useEffect, useContext } from 'react';

import { GlobalContext } from '../../../store';

import BackToTop from '../../../components/BackToTop';
import { LeaderBoard } from '../../../components/LeaderBoard/LeaderBoard';
import LeaderboardHeader from '../../../components/LeaderboardHeader/LeaderboardHeader';
import Select from '../../../components/Select';
import { parseStandings } from './Utils/parseStandings';

interface IProps {
  clubId: number;
}

const IndividualLeaderboards: FC<IProps> = props => {
  const { clubId } = props;

  const { actions, standings } = useContext(GlobalContext);

  useEffect(() => {
    actions.clubs.get(clubId);

    actions.standings.getByClub(clubId);
  }, [clubId, actions]);

  const parsedStandings = standings.byClub[clubId] ? parseStandings(standings.byClub[clubId]) : [];

  return (
    <div className="home individual-leaderboards wrapper">
      <div>
        <LeaderboardHeader title="STANDINGS & LEADERBOARDS">
          <Select
            title="Season"
            noAngleTitle={true}
            onSelect={() => null}
            options={[{ label: 'Current Season', value: '1' }]}
          />

          <h4 className="leaderboard-header__subtitle">PLAYER OF THE YEAR</h4>

          <p className="leaderboard-header__description">
            Player of the year points are earned based on NET finishes in our events. Check out the
            policy section for all the details.
          </p>
        </LeaderboardHeader>

        <LeaderBoard parsedStandings={parsedStandings} />

        <div className="back-to-top-container">
          <BackToTop scrollStepInPx={50} delayInMs={16.66} />
        </div>
      </div>
    </div>
  );
};

export default IndividualLeaderboards;
